<template lang="pug">
#app
	.display-states
		display-state(
			v-for='( state, key ) in displayStates'
			:key='key'
			:options='state'
		)
	.update-container(v-if='isElectronApp && updateAvailable')
		.update-notification
			.text
				p Application is updating...
				p {{ updateProgress }}% / 100%
			.progress-bar
				.completed(:style='{ flex : "1 1 " + updateProgress + "%" }')
				.total(:style='{ flex : "1 1 " + ( 100 - updateProgress ) + "%" }')
	router-view
</template>

<script>
import isElectron from 'is-electron';
import { mapActions } from 'vuex';
import { OnAuthStateChanged } from '@/lib/db/auth';
import { GetUserByUID } from '@/lib/API';
import SideNav from './components/SideNav';
import DisplayState from './components/DisplayState';


export default {
	name : 'app',

	data : () => ( {
		updateAvailable : false,
		updateProgress  : 0,
	} ),

	methods : {
		...mapActions( [
			'initAuthListener',
		] )
	},

	created() {

		this.initAuthListener();

		OnAuthStateChanged( ( user ) => {

			if ( user === null ) {
				this.$router.replace( { path : '/login' } );
			}

		} );

		if ( this.isElectronApp ) {
			this.$router.replace( { path : '/app/home' } );

			window.ipcRenderer.on( 'message', ( event, text ) => {
				// console.log( text );

				if ( text === 'update-available' ) {
					this.updateAvailable = true;
				}
			} );

			window.ipcRenderer.on( 'download-progress', ( event, progressObj ) => {
				this.updateProgress = Math.round( progressObj.percent );
			} );

			window.document.addEventListener( 'keyup', ( {
				key, ctrlKey, shiftKey, metaKey, altKey
			} ) => {
				if (
					key === 'F12'
					|| ( ctrlKey && shiftKey && key === 'I' )
					|| ( metaKey && altKey && key === 'i' )
				) {
					window.ipcRenderer.send( 'open-dev-tools' );
				}
			} );
		}

	},

	computed : {

		displayStates() {
			return this.$store.state.displayStates;
		},

		isElectronApp() {
			return isElectron();
		},

		loginState() {
			return this.$store.state.loginState;
		},

		user() {
			return this.$store.state.user;
		}

	},

	watch : {
		user : {
			deep : true,
			async handler( user ) {
				if ( !user.name ) {
					return;
				}
				const postgresUser = await GetUserByUID( this.user.uid );
				// console.log( 'postgresUser' );
				// console.log( postgresUser );
				// console.log( user );
				postgresUser[0].uid = this.user.uid;
				this.$store.commit( 'updatePostgresUser', postgresUser[0] );
				this.$store.dispatch( 'validateDriveLink' );
			}
		}
	},

	components : {
		'side-nav' : SideNav,
		DisplayState,
	}
};
</script>


<style lang="scss">
#app{
	display: flex;
	height: 100%;

	.update-container {
		position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #757e8b33;
    z-index: 1000;

		.update-notification {
			position: absolute;
			background: #ffffff;
			width: 600px;
			left: 50%;
			top: 40%;
			transform: translateX(-50%);
			padding: 25px;

			.text {
				display: flex;
				justify-content: space-between;
				margin-bottom: 15px;

				p {
					font-size: 20px;
					letter-spacing: 2px;
				}
			}

			.progress-bar {
				width: 100%;
				height: 10px;
				border-radius: 5px;
				display: flex;
				overflow: hidden;

				.completed {
					background: #88ba80;
				}

				.total {
					background: #e4e4e4;
				}
			}
		}
	}
}

body,
main,
figure,
ul,
li {
	margin: 0;
	padding: 0;
}

.display-states {
	position: fixed;
	display: flex;
	flex-flow: column;
	flex-direction: reverse;
	z-index: 1000;
	bottom: 15px;
	left: 15px;

	.display-state + .display-state {
		margin-top: 15px;
	}
}
</style>
